;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = require("./Button.vue");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Button: _Button2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ss-aside"},[_vm._m(0),_c('div',{staticClass:"ss-aside__body"},[_c('div',{staticClass:"ss-aside__image"},[_c('svg',{staticClass:"ss-aside__informer",attrs:{"viewBox":"0 0 500 100"}},[_c('path',{staticClass:"ss-aside__path",attrs:{"id":"text","fill":"none","d":"M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97"}}),_c('text',{staticClass:"ss-aside__text",attrs:{"fill":"white"}},[_c('textPath',{staticClass:"ss-aside__textPath",attrs:{"startOffset":"50%","xlink:href":"#text","text-anchor":"middle"}},[_vm._v("225/45 R17")])])])])]),_c('div',{staticClass:"ss-aside__footer"},[_c('div',{staticClass:"ss-aside__button"},[_c('Button',{attrs:{"styles":["has-caption", "is-wide", "is-advice"],"type":"a","href":"#","label":"Подобрать шину","caption":"Как правильно"}})],1)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"ss-aside__header"},[_c('h3',{staticClass:"ss-aside__title"},[_vm._v("Шина Сервис")]),_c('p',{staticClass:"ss-aside__subtitle"},[_vm._v("Широкий ряд наименований летней и зимней резины")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e07d6208", __vue__options__)
  } else {
    hotAPI.reload("data-v-e07d6208", __vue__options__)
  }
})()}